import { RefObject, useEffect, useRef, useState } from 'react';

export const useOnVisible = (ref: RefObject<HTMLElement>, resetTrigger?: boolean) => {
  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (ref && ref.current) {
      observerRef.current = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting));
      observerRef.current.observe(ref.current);

      return () => {
        observerRef.current?.disconnect();
        observerRef.current = null;
      };
    }
  }, [ref, resetTrigger]);

  return isVisible;
};
